import {WixSdk} from '@wix/js-sdk-wrapper';
import {Observable} from 'rxjs';
import {take, tap} from 'rxjs/operators';
import {WidgetSettings} from '../../../typings/settings';

export function scrollToPlayer($settings: Observable<WidgetSettings>) {
  return $settings.pipe(
    take(1),
    tap((settings) => {
      // todo: check
      if (settings.sharedTrackId) {
        WixSdk.getBoundingRectAndOffsets().then((rectAndOffsets) => {
          const offsets = rectAndOffsets.offsets;
          WixSdk.scrollTo(offsets.x, offsets.y - 20); // 20 to look better
        });
      }
    }),
  );
}
